import { Injectable } from '@angular/core';
import { AuthService } from '../../api/services/auth.service';
import { PreferencesService } from '../../api/services/preferences.service';
import { UserService } from '../../api/services/user.service';
import { of } from 'rxjs/observable/of';
import { Subject } from 'rxjs/Subject';
import { delay } from 'rxjs/operators';


@Injectable()
export class ThemeService {

  private themeSubject = new Subject<string>();

  constructor(
    private authService: AuthService,
    private userService: UserService,
    private preferencesService: PreferencesService) { }

  getTheme() {
    of([]).pipe(delay(0)).subscribe(() => {
      const currentTheme = this.authService.getTheme();

      currentTheme && this.themeSubject.next(currentTheme);

      !currentTheme && this.getThemeFromServer()
        .subscribe(theme => {
          this.authService.storeTheme(theme);
          this.themeSubject.next(theme);
        }
      );
    });

    return this.themeSubject;
  }

  refreshTheme() {
    this.getThemeFromServer()
    .subscribe(theme => {
      this.authService.storeTheme(theme);
      this.themeSubject.next(theme);
    });
  }

  private getThemeFromServer() {
    return this.userService.findUserById(this.authService.getUserId())
    .switchMap(user => this.preferencesService.getPreferences('CUSTOMER', user['Organization ID']))
    .map(prefs => prefs['theme-color'].Value || 'almost-black');
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src3408204168/src/bitbucket.org/tesscotds/webclient/src/app/services/theme.service.ts